import React, { createContext, useContext, useMemo } from 'react';

export function isEmbedPath() {
  return typeof window !== 'undefined' && window.location.pathname.startsWith('/embed');
}

const EmbedContext = createContext({
  isEmbedMode: false,
  getEmbedHeaders: () => ({}),
});

export function EmbedProvider({ children }) {
  const value = useMemo(
    () => ({
      isEmbedMode: true,
      getEmbedHeaders: () => ({ 'X-Embed-Mode': '1' }),
    }),
    [],
  );

  return <EmbedContext.Provider value={value}>{children}</EmbedContext.Provider>;
}

export function useEmbed() {
  return useContext(EmbedContext);
}

export function getEmbedHeaders() {
  return isEmbedPath() ? { 'X-Embed-Mode': '1' } : {};
}
